import { reducerWithInitialState } from "typescript-fsa-reducers"
import { cameraOffActions } from "../actions/CameraOffAction"

export interface CameraOffState {
  cameraOff: boolean // true → カメラ機能無し版のTOP画面へ遷移
}

const initialState: CameraOffState = {
  cameraOff: false
}
// Reduxを利用した画面間共通のCameraOffState初期化処理
export const cameraOffReducer = reducerWithInitialState(initialState)
  .case(cameraOffActions.updateCameraOff, (state, cameraOff) => {
    return { ...state, cameraOff }
  })
  .default((state) => {
    return state
  })
